import { registerTenant, TenantId } from '~/tenants/common/registry';
import { MLM_CUSTOMER_JOB_METADATA } from '~/tenants/mlm/job-metadata';
import { TimeZone } from '~/lib/enum';
import EmptyForm from '~/tenants/common/forms/EmptyForm';
import MlmProvider from '~/tenants/mlm/model/MlmProvider';
import MlmCustomer, { MlmCustomerSchema } from '~/tenants/mlm/model/MlmCustomer';
import { MLM_CUSTOMER_ORDER_METADATA, MlmOrderSchema } from '~/tenants/mlm/model/MlmOrder';
import { MLM_PROVIDER_DATA } from '~/tenants/mlm/data';
import Mlm3dConfig from '~/tenants/mlm/performable/3d/Mlm3dConfig';
import Mlm3dJob from '~/tenants/mlm/performable/3d/Mlm3dJob';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import MlmPhotosJob from '~/tenants/mlm/performable/photos/MlmPhotosJob';
import MlmPhotosForm from '~/tenants/mlm/performable/photos/MlmPhotosForm';
import MlmAerialConfig from '~/tenants/mlm/performable/aerial/MlmAerialConfig';
import MlmAerialJob from '~/tenants/mlm/performable/aerial/MlmAerialJob';
import MlmAerialForm from '~/tenants/mlm/performable/aerial/MlmAerialForm';
import MlmFloorplanConfig from '~/tenants/mlm/performable/floorplan/MlmFloorplanConfig';
import MlmFloorplanJob from '~/tenants/mlm/performable/floorplan/MlmFloorplanJob';
import MlmVirtualStagingConfig from '~/tenants/mlm/performable/staging/MlmVirtualStagingConfig';
import { MlmVirtualJob } from '~/tenants/mlm/performable/virtual/MlmVirtualJob';
import MlmVirtualStagingJob from '~/tenants/mlm/performable/staging/MlmVirtualStagingJob';
import MlmVirtualStagingForm from '~/tenants/mlm/performable/staging/MlmVirtualStagingForm';
import MlmFlyerConfig from '~/tenants/mlm/performable/flyer/MlmFlyerConfig';
import MlmFlyerJob from '~/tenants/mlm/performable/flyer/MlmFlyerJob';
import MlmFlyerForm from '~/tenants/mlm/performable/flyer/MlmFlyerForm';
import MlmBrochuresConfig from '~/tenants/mlm/performable/brochures/MlmBrochuresConfig';
import MlmBrochuresJob from '~/tenants/mlm/performable/brochures/MlmBrochuresJob';
import MlmBrochuresForm from '~/tenants/mlm/performable/brochures/MlmBrochuresForm';
import MlmHeadshotConfig from '~/tenants/mlm/performable/headshot/MlmHeadshotConfig';
import MlmHeadshotJob from '~/tenants/mlm/performable/headshot/MlmHeadshotJob';
import MlmHeadshotForm from '~/tenants/mlm/performable/headshot/MlmHeadshotForm';
import MlmVirtualConfig from '~/tenants/mlm/performable/virtual/MlmVirtualConfig';
import MlmVirtualForm from '~/tenants/mlm/performable/virtual/MlmVirtualForm';
import MlmWalkthroughConfig from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughConfig';
import MlmWalkthroughJob from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughJob';
import MlmWalkthroughForm from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughForm';
import MlmOrderForm from '~/tenants/mlm/forms/MlmOrderForm';
import { MlmOrder } from '~/tenants/mlm/model/MlmOrder';
import MlmFundamentalsPackageConfig from '~/tenants/mlm/package/fundamentals/MlmFundamentalsPackageConfig';
import MlmFundamentalsPackageForm from '~/tenants/mlm/package/fundamentals/MlmFundamentalsPackageForm';
import MlmStarterPackageConfig from '~/tenants/mlm/package/starter/MlmStarterPackageConfig';
import MlmStarterPackageForm from '~/tenants/mlm/package/starter/MlmStarterPackageForm';
import MlmHeatPackageConfig from '~/tenants/mlm/package/heat/MlmHeatPackageConfig';
import MlmHeatPackageForm from '~/tenants/mlm/package/heat/MlmHeatPackageForm';
import MlmLetsGoPackageConfig from '~/tenants/mlm/package/letsgo/MlmLetsGoPackageConfig';
import MlmLetsGoPackageForm from '~/tenants/mlm/package/letsgo/MlmLetsGoPackageForm';
import MlmStokedPackageConfig from '~/tenants/mlm/package/stoked/MlmStokedPackageConfig';
import MlmStokedPackageForm from '~/tenants/mlm/package/stoked/MlmStokedPackageForm';

export default function registerMlm() {
  registerTenant(TenantId.MAINE_LINE_MEDIA, MlmOrderSchema, {
    name: 'Maine Line Media',
    domain: 'orders.mainelinemedia.com',
    phone: '+12077473388',
    logoRaster: 'https://optimize.photology.co/tenant/mlm/logo2.png',
    logoVector: 'https://optimize.photology.co/tenant/mlm/logo2.svg',
    background: '#7A9B73',
    legal: 'Maine Line Media LLC',
    email: 'contact@mainelinemedia.com',
    emailEnable: true,
    emailDeliverAppointment: true,
    brochureDisabled: true,
    userback: true,
    tax: '0.055',
    providerClass: MlmProvider,
    providers: MLM_PROVIDER_DATA,
    rainforestEnable: true,
    rainforestMerchantId: 'mid_35JFyVKIqJQ7dkIoZSeh1R1Or04',
    rainforestMerchantApplicationId: 'app_35JFySgCRjiFDYciVBOPfA7sQNY',
    scheduleStartTime: '07:30',
    scheduleEndTime: '20:00',
    customerClass: MlmCustomer,
    phaseDefault: 'delivered',
    locations: [
      {
        slug: 'sme',
        name: 'Saco',
        timezone: TimeZone.US_EASTERN,
        address: {
          line1: '43 Hearn Road',
          city: 'Saco',
          state: 'ME',
          zip: '04072',
          lat: 43.561428,
          long: -70.432344,
        },
      },
    ],
    orderClass: MlmOrder,
    packages: [
      {
        config: MlmFundamentalsPackageConfig,
        form: MlmFundamentalsPackageForm,
      },
      {
        config: MlmStarterPackageConfig,
        form: MlmStarterPackageForm,
      },
      { config: MlmHeatPackageConfig, form: MlmHeatPackageForm },
      { config: MlmLetsGoPackageConfig, form: MlmLetsGoPackageForm },
      { config: MlmStokedPackageConfig, form: MlmStokedPackageForm },
    ],
    customerOrderMetadata: MLM_CUSTOMER_ORDER_METADATA,
    customerSchema: MlmCustomerSchema,
    customerJobMetadata: MLM_CUSTOMER_JOB_METADATA,
    forms: {
      orderConfigure: MlmOrderForm,
      provider: EmptyForm,
    },
    actions: [],
    performables: {
      [MlmPhotosConfig.id]: {
        config: MlmPhotosConfig,
        job: MlmPhotosJob,
        form: MlmPhotosForm,
      },
      [MlmAerialConfig.id]: {
        config: MlmAerialConfig,
        job: MlmAerialJob,
        form: MlmAerialForm,
      },
      [Mlm3dConfig.id]: {
        config: Mlm3dConfig,
        job: Mlm3dJob,
        form: EmptyForm,
      },
      [MlmFloorplanConfig.id]: {
        config: MlmFloorplanConfig,
        job: MlmFloorplanJob,
        form: EmptyForm,
      },
      [MlmVirtualStagingConfig.id]: {
        config: MlmVirtualStagingConfig,
        job: MlmVirtualStagingJob,
        form: MlmVirtualStagingForm,
      },
      [MlmFlyerConfig.id]: {
        config: MlmFlyerConfig,
        job: MlmFlyerJob,
        form: MlmFlyerForm,
      },
      [MlmBrochuresConfig.id]: {
        config: MlmBrochuresConfig,
        job: MlmBrochuresJob,
        form: MlmBrochuresForm,
      },
      [MlmHeadshotConfig.id]: {
        config: MlmHeadshotConfig,
        job: MlmHeadshotJob,
        form: MlmHeadshotForm,
      },
      [MlmVirtualConfig.id]: {
        config: MlmVirtualConfig,
        job: MlmVirtualJob,
        form: MlmVirtualForm,
      },
      [MlmWalkthroughConfig.id]: {
        config: MlmWalkthroughConfig,
        job: MlmWalkthroughJob,
        form: MlmWalkthroughForm,
      },
    },
  });
}
